import type { ReactNode } from "react";
import ConfirmationModal from "../blocks/ConfirmationModal";

interface Props {
  title?: string;
  msg: ReactNode;
  onClick: () => void;
}

const ModalAlert = ({ title = "error", msg, onClick }: Props) => (
  <ConfirmationModal
    onConfirm={onClick}
    onCancel={onClick}
    confirmButtonText="Continue"
    modalButtonText={null}
    title={title}
    defaultShowState={true}
    confirmationMessage={msg}
    hideCancelButton={true}
    confirmButtonStyles={{ transform: "none", marginTop: "1rem" }}
  />
);

export default ModalAlert;
